import React from 'react';
import { connect } from 'react-redux';
import { setFiltroTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { customStyle } from '../../template/CustomStyle';
import Select from 'react-select';


class FiltroTipoPublicaciones extends React.Component{
    constructor (props){
        super(props);
        this.estadoOptions = [
            { value: 0, label: 'VIGENTE' },
            { value: 2, label: 'DESHABILITADO' }
        ];
        this.state = {
            descripcion: this.props.filtro?.descripcion ?? "",
            cantidadPagina: 10,
            numeroPagina: 1,
            estado: typeof this.props.filtro?.estado === 'undefined' ? null : this.props.filtro.estado,
        }
    }

    myChangeHandler = async (e) =>{
        const { name, value } = e.target;
        this.setState({[name]: value});
        this.props.setFiltroTiposPublicacion({ ...this.props.filtro, [name]: value });
    }

    selectSearchHandler = (selectedOption) => {
        const estado = selectedOption ? selectedOption.value : null;
        this.setState({ estado });
        // Solo actualiza el filtro en Redux, no ejecuta búsqueda automática
        this.props.setFiltroTiposPublicacion({ ...this.props.filtro, estado });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.state.descripcion !== undefined || this.state.descripcion !== "") {
            this.props.updateParams({
                descripcion: this.state.descripcion,
                estado: this.state.estado,
                cantidadPagina: this.state.cantidadPagina,
                numeroPagina: this.state.numeroPagina
            });
        }
        this.props.setFiltroTiposPublicacion({ ...this.props.filtro, numeroPagina: 1 });
    }

    verTodos = () => {
        const filtroReset = { descripcion: "", estado: null, numeroPagina: 1, cantidadPagina: 10 };
        this.props.setFiltroTiposPublicacion(filtroReset);
        this.setState({ descripcion: "", estado: null }, () => {
            // Llamar updateParams con 'Estado' explícito null para forzar fetch de todos
            this.props.updateParams({ ...filtroReset, Estado: null, Page: 1, PageSize: 10 });
            if (typeof this.props.clearFilter === 'function') {
                this.props.clearFilter();
            }
        });
    }

    render() {
        return ( 
            <div className="card card-body filter-card">
                <form className="row justify-content-start align-items-center form-material"
                    onSubmit={this.onSubmit}
                    onReset={this.verTodos}
                >
                    <div className="col-12 col-sm-3">
                        <label className="label-oscura">Descripción</label>
                        <input 
                            type="text" 
                            name="descripcion" 
                            value={this.state.descripcion} 
                            className="form-control" 
                            onChange={this.myChangeHandler}
                        />
                    </div>
                     <div className="col-12 col-sm-3">
                        <label className="label-oscura">Estado</label>
                        <Select
                            name="estado"
                            options={this.estadoOptions}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado === null ? null : this.estadoOptions.find(opt => opt.value === this.state.estado)}
                            styles={customStyle}
                        />
                    </div>
                    <div className="col-12 col-sm-auto">
                        <div className="row justify-content-center justify-content-sm-end">
                            <button 
                                type="submit"
                                className="btn btn-sm btn-grey d-inline col-auto mx-3 mt-2 mt-sm-0"
                            >
                                Buscar
                            </button>
                            <button 
                                type='reset'
                                className="btn btn-sm btn-grey d-inline col-auto mt-2 mt-sm-0"
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        ); 
    }
}
const mapStateToProps = state => ({
   
     filtro: state.tiposPublicacion.filtro
});

export default connect(mapStateToProps, { setFiltroTiposPublicacion})(FiltroTipoPublicaciones);

